import { useState } from "react";

export const ShowTasks = ({taskstarted, setTackstarted, tasklist, setTesklist}) => {

    
    const handleDelete = (id)=> {
        const deleteID = tasklist.filter ( (task)=> (task.id !== id) );

        setTesklist(deleteID);

        if (tasklist.length === 1){
            setTackstarted("ALL TASKS HAVE BEEN REMOVED !");
        }

    }

  return (
    <>
    <section className="showTask">
        <div className="head">
            <div>
            <span className="title">Todo</span>
            <span className="count">{tasklist.length}</span>
            </div>
            <button onClick={()=> setTesklist([])} className="clearAll">Clear</button>
        </div>
        <ul>
            {tasklist && tasklist.map ( (task)=>( 
                <li key={task.id}>
                <p>
                    <span className="name">{task.name}</span>
                    <span className="date">{task.time}</span>
                </p>
               
                <i  onClick={()=> handleDelete(task.id)} className="bi bi-trash"></i>
            </li>
                )  )}
            {taskstarted}
            
                
                        
        </ul>
    </section>
    </>

  )
}
